import { createContext } from 'react';

const VasContext = createContext({
    vasAvailable: false,
    setVasAvailable: () => {
        //code
    },
    dealSKU: undefined,
    setDealSKU: () => {
        //code
    },
    vasList: [],
    setVasList: () => {
        //code
    }
});
export default VasContext;